import { NodeModel } from "../_model/NodeModel";
import { DecorationStrainer } from "./decorationStrainer";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Strainer extends NodeModel {
    constructor() {
        super("Strainer");

        this.type = new Types().Strainer;
        
        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 100;
        this.width = 120;
        this.operationSelected = "";
        this.srcImg = require("@/assets/Fluxogramas/peneira.png");
        this.data = [new Properties({...this })];
        this.jokerCaption = [];

        this.decorate = async function(callback) {
            this.decorator = new DecorationStrainer();
            await this.decorator.init(this, callback);
        };

        this.clone = () => {
            let cloned = new Strainer();
            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null;
            cloned.readOnly = this.readOnly;
            cloned.expressionVisible = this.expressionVisible
            cloned.jokerCaption = this.jokerCaption
            cloned.data = this.data.map(d => d.clone());

            return cloned;
        };

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.jokerCaption = node.jokerCaption
            this.data = node.data.map((d) => new Properties({...d }));
        };

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
            
            this.jokerCaption = node.jokerCaption;
        };
    }
}

export { Strainer };